
export interface MoodFilterData {
  id: string;
  prompt_name: string;
  priority: number;
  tags: string[];
}

export const MOOD_FILTERS: MoodFilterData[] = [
  {
    id: "mood-happy",
    prompt_name: "Happy",
    priority: 100,
    tags: ["joyful", "positive"]
  },
  {
    id: "mood-dramatic",
    prompt_name: "Dramatic",
    priority: 90,
    tags: ["intense", "powerful"]
  },
  {
    id: "mood-peaceful",
    prompt_name: "Peaceful",
    priority: 80,
    tags: ["calm", "serene"]
  },
  {
    id: "mood-mysterious",
    prompt_name: "Mysterious",
    priority: 70,
    tags: ["enigmatic", "dark"]
  },
  {
    id: "mood-energetic",
    prompt_name: "Energetic",
    priority: 60,
    tags: ["dynamic", "vibrant"]
  },
  {
    id: "mood-romantic",
    prompt_name: "Romantic",
    priority: 50,
    tags: ["loving", "intimate"]
  },
  {
    id: "mood-melancholy",
    prompt_name: "Melancholy",
    priority: 40,
    tags: ["sad", "reflective"]
  },
  {
    id: "mood-surreal",
    prompt_name: "Surreal",
    priority: 30,
    tags: ["dreamlike", "abstract"]
  },
  {
    id: "mood-nostalgic",
    prompt_name: "Nostalgic",
    priority: 20,
    tags: ["vintage", "memories"]
  },
  {
    id: "mood-futuristic",
    prompt_name: "Futuristic",
    priority: 10,
    tags: ["sci-fi", "modern"]
  }
];
